<template>
  <div class="columnar_bar">
    <div class="barEcharts" ref="columnarBar_statistics" style="height:100%;width:100%;">

    </div>
    <!-- <div class='precent' >
      <p  class='item' v-for='(item,index) in percent' :key='index'>
        {{(item * 100).toFixed(1) }}%
      </p>
    </div> -->
  </div>
</template>

<script>
import EChart from 'echarts'

export default {
    props:{
        areaData:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data () {
        return {
          columnarBar_statistics:{
              option: {},
              chart: null,
              element: {},
          },
          percent:[0.50, 0.34, 0.67, 0.666, 0.888],
          area_data:{},
          chartArray:['columnarBar_statistics'],
        }
    },
    mounted() {
      // this.$nextTick(()=>{
      //   setTimeout(()=>{
      //     window.addEventListener('resize', this.onWindowResize)
      //     this.onWindowResize();
      //
      //   },1500);
      // });

    },
    watch:{
        areaData: {
            handler:function(newVal,oldVal){
              if(JSON.stringify(newVal)!== "{}")
                if(newVal !== oldVal){
                  setTimeout(()=>{
                     this.pageInit();
                  },1000)
                }
            },
            deep:true
        },
    },
    beforeDestroy(){
        window.removeEventListener('resize',this.onWindowResize);
      this.columnarBar_statistics.chart.clear();

    },
    destory(){
        // window.onresize = null;
    },
    methods: {
        //根据页面调整
      onWindowResize(){
        // let pageHeight = document.documentElement.clientHeight; //页面总高度
        // let barStyle = document.querySelectorAll(".device")[0].clientHeight;
        if(document.querySelectorAll(".right_wrap") && document.querySelectorAll(".right_wrap")[0]){
          let barStyle = document.querySelectorAll(".right_wrap")[0].clientHeight;
          console.log('cp;i,mar页面高度-=-=-=clientHeight-=--=-'+barStyle)

          document.querySelectorAll(".barEcharts")[0].style.height =  barStyle - 30 + 'px';  //在这里可以根据你的边距做调整
          let chartBox = this.columnarBar_statistics.chart
          var width = chartBox.clientWidth
          let option = chartBox.getOption()
          if (width) {
            chartBox.resize()
            chartBox.setOption(option, true)
          }

          if(JSON.stringify(this.areaData) !== "{}" )this.disposeAllChart();
        }
      },
        pageInit(){
            this.area_data = this.$deepClone(this.areaData);
            this.initData();
        },
        initData(){
            var all_data = this.area_data.all_data;//背景数据
            // var titlename = ['密云区', '昌平区', '顺义区', '平谷区', '房山区', '东城区', '西城区', '朝阳区'];
            // var valdata = [4, 13, 25, 29, 38, 44, 50, 52]
            var titlename = this.area_data.y_data;
            var valdata = this.area_data.series_data;
          console.log('area_data-=-=-=-=-'+ JSON.stringify(this.area_data))

            var myColor = ['#1089E7', '#F57474', '#56D0E3', '#F8B448', '#8B78F6'];
            this.columnarBar_statistics.option = {
                 grid: {
                    left: '10%',
                    top: '12%',
                    right: '5%',
                    bottom: '8%',
                    containLabel: true
                },
                xAxis: {
                    show: false,
                },
                yAxis: [{
                        axisTick: 'none',
                        axisLine: 'none',
                        offset: '10',
                        show: true,
                        data: titlename,
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: '#fff',
                            fontSize:12
                        },


                    },
                    {
                        show: true,
                        inverse: true,
                        data: valdata,
                        axisLabel: {
                            textStyle: {
                                fontSize: 12,
                                color: '#fff',
                            },
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },

                    }
                ],
                series: [
                    {
                        name: '件',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: valdata,
                        barWidth: 12,
                        itemStyle: {
                            normal: {
                                color: {
                                    type: 'bar',
                                    colorStops: [{
                                        offset: 0,
                                        color: '#135595' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#3fc4d8' // 100% 处的颜色
                                    }],
                                    globalCoord: false, // 缺省为 false

                                }
                            },
                        },
                        z: 2
                    },
                     {
                        name: '背景',
                        type: 'bar',
                        yAxisIndex: 1,
                        barGap: '-100%',
                        data: all_data,
                        barWidth: 15,
                        itemStyle: {
                            normal: {
                                color: '#0c2253',
                                barBorderRadius: 0,
                            }
                        },
                        z: 1
                    }
                ]
            };
            // if(this.columnarBar_statistics.chart!=null&&this.columnarBar_statistics.chart!=''&&this.columnarBar_statistics.chart!=undefined){
            //   this.columnarBar_statistics.chart.dispose();
            // }
            this.columnarBar_statistics.chart = EChart.init(this.$refs.columnarBar_statistics);
            this.columnarBar_statistics.chart.setOption(this.columnarBar_statistics.option);
            // window.addEventListener('resize', this.onWindowResize);
            // this.columnarBar_statistics.chart.resize();
        },
        //释放图表，销毁对象
        disposeAllChart(){
            let i = 0 , len = this.chartArray.length
            for (;i < len; i++){
                let a = this.chartArray[i]
                if(this[a].chart){
                    this[a].chart.dispose()
                }
            }
            this.initData()
        }
    }
}
</script>
<style scoped lang='less'>
.columnar_bar{
    border-right:0;
    border-left: 0;
    width:100%;
    height:100%;
    /* background-color: red; */
    .barEcharts{
        width: 100%;
        height:100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/chart/columnar_bar.vue